import graphqlApi from './api'

const getCurrentIp = () => graphqlApi.post('/', {
  query: `
    query {
      getClientIp
    }
  `,
}).then(res => Promise.resolve(res?.data?.data?.getClientIp)).catch(err => Promise.reject(err))

export default getCurrentIp
